import FileHandler from "@tiptap/extension-file-handler"

import { storedAttachmentFileName } from "./stored-attachment-file-name"

export type PastedFilesHandler = (files: File[]) => void

export function composerFilePasteExtension(currentPastedFilesHandler: () => PastedFilesHandler | undefined) {
  return FileHandler.configure({
    consumePasteEvent: false,
    onPaste: (_editor, files) => currentPastedFilesHandler()?.(files),
  })
}

export function pasteAttachesFiles(clipboard: DataTransfer): boolean {
  return clipboard.files.length > 0 && !htmlHasVisibleText(clipboard.getData("text/html"))
}

function htmlHasVisibleText(html: string): boolean {
  if (!html) return false
  const visibleText = new DOMParser().parseFromString(html, "text/html").body.textContent ?? ""
  return visibleText.trim().length > 0
}

export function uniquelyNamedFiles(addedFiles: File[], takenFileNames: string[]): File[] {
  const taken = new Set(takenFileNames.map(storedAttachmentFileName))
  return addedFiles.map((addedFile) => {
    const uniqueName = nextAvailableFileName(storedAttachmentFileName(addedFile.name), taken)
    taken.add(uniqueName)
    if (uniqueName === addedFile.name) return addedFile
    return new File([addedFile], uniqueName, { type: addedFile.type })
  })
}

function nextAvailableFileName(fileName: string, taken: Set<string>): string {
  if (!taken.has(fileName)) return fileName
  const dotIndex = fileName.lastIndexOf(".")
  const baseName = dotIndex === -1 ? fileName : fileName.slice(0, dotIndex)
  const extension = dotIndex === -1 ? "" : fileName.slice(dotIndex)
  for (let suffix = 2; ; suffix += 1) {
    const candidate = `${baseName}-${suffix}${extension}`
    if (!taken.has(candidate)) return candidate
  }
}
